<template>
<div>
	  <div class="grafiek">
		<label class="switch">
		<input type="checkbox" v-model="allDataVisible">
		<span class="slider"></span>
	  </label>
	  <span>{{ allDataVisible ? ' &nbsp Toon laatste drie jaar' : ' &nbsp Toon alle jaren' }}</span>
		<div v-for="(leerlingaantal, index) in filteredLeerlingaantallen" :key="index">
		  <div class="staaf" :style="`width:${leerlingaantal.staafWidth}px;`"></div>
		  {{ leerlingaantal.aantal }} leerlingen ({{ leerlingaantal.schooljaar }})
		</div>
	  </div>
	</div>
  </template>
  <script>
  export default {
	props: {
	  school: {
		type: Object,
		required: true,
	  },
	  leerlingaantallen: {
		type: Object,
		required: true,
	  },
	},
	data() {
	  return {
		allDataVisible: false,
	  };
	},
	computed: {
	  filteredLeerlingaantallen() {
		let result = this.leerlingaantallenData.slice(0, 3);
		if (this.allDataVisible) {
		  result = this.leerlingaantallenData;
		}
		return result;
	  },
	  leerlingaantallenData() {
		if (!this.leerlingaantallen) {
		  return [];
		}
		// Convert object to array
		let result = [];
		for (const [schooljaar, aantal] of Object.entries(this.leerlingaantallen)) {
		  if (!aantal) {
			continue;
		  }
		  result.push({ schooljaar, aantal });
		}
		// Sort descending schooljaar
		result = result.sort((a, b) => {
		  if (a.schooljaar > b.schooljaar) {
			return -1;
		  }
		  return 1;
		});
		// Calculate the appropriate bar length
		const biggestSchoolYear = result.reduce((prev, cur) => {
		  if (!prev) {
			return cur;
		  }
		  if (cur.aantal > prev.aantal) {
			return cur;
		  }
		  return prev;
		}, null);
		// Calculate the scaling factor for bar width
		const staafWidthScale = parseInt(biggestSchoolYear.aantal, 10) / 350;
		// Format the student counts with dot for thousands separator
		result.forEach((l) => {
		  const formattedAantal = l.aantal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
		  l.aantal = formattedAantal;
		  // Calculate the bar width
		  l.staafWidth = Math.round(parseInt(l.aantal.replace('.', ''), 10) / staafWidthScale);
		});
		return result;
	  },
	},
	methods: {
	  toggleVisibility() {
		this.allDataVisible = !this.allDataVisible;
	  },
	},
  };
  </script>
<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
input:checked + .slider {
  background-color: #6bc6de;
}
input:focus + .slider {
  box-shadow: 0 0 1px #6bc6de;
}
input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}
</style>